import { render, staticRenderFns } from "./Input-Schema.vue?vue&type=template&id=cf3b3eb6&lang=pug"
import script from "./Input-Schema.vue?vue&type=script&lang=ts"
export * from "./Input-Schema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports